import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// SYSTEMONE
import Swal from "sweetalert2";
import BaseMixer from "@/router/views/BaseMixer";
let DeleteComponent = /** @class */ (() => {
    var _a, _b;
    let DeleteComponent = class DeleteComponent extends Mixins(BaseMixer) {
        deletionConfirmation() {
            Swal.fire({
                customClass: {
                    container: "remove-swal2-container",
                    title: "remove-swal2-title",
                    popup: "remove-swal2-popup",
                    icon: "remove-swal2-icon",
                },
                title: this.title,
                text: `You won't be able to revert this!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    return this.save();
                }
                return this.cancel();
            });
        }
        save() { }
        cancel() { }
        created() {
            this.deletionConfirmation();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof String !== "undefined" && String) === "function" ? _a : Object)
    ], DeleteComponent.prototype, "title", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_b = typeof String !== "undefined" && String) === "function" ? _b : Object)
    ], DeleteComponent.prototype, "text", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DeleteComponent.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DeleteComponent.prototype, "cancel", null);
    DeleteComponent = __decorate([
        Component({
            name: "DeleteComponent",
            components: {},
        })
    ], DeleteComponent);
    return DeleteComponent;
})();
export default DeleteComponent;
